// extracted by mini-css-extract-plugin
export var boldText = "_3x-4";
export var checkboxContainer = "_3x-6";
export var closeIcon = "_3x-i";
export var container = "_3x-0";
export var drawer = "_3x-8";
export var drawerContent = "_3x-9";
export var extraSmallText = "_3x-5";
export var fulfillmentGroupTable = "_3x-e";
export var largeText = "_3x-3";
export var loadingSpinnerContainer = "_3x-j";
export var mediumText = "_3x-2";
export var narrow = "_3x-f";
export var notificationLink = "_3x-l";
export var packageCheckIconContainer = "_3x-7";
export var slideoutHeaderActions = "_3x-g";
export var slideoutHeaderActionsShifted = "_3x-h";
export var slideoutHeaderContainer = "_3x-a";
export var slideoutModal = "_3x-c";
export var stickyHeaderWrapper = "_3x-b";
export var table = "_3x-k";
export var tableContainer = "_3x-d";
export var tertiaryText = "_3x-1";